import { Component, EventEmitter, Query, ViewChild, ViewChildren, ContentChildren, Directive, ElementRef, QueryList, OnInit } from '@angular/core';
import { DomSanitizer, SafeResourceUrl, SafeUrl} from '@angular/platform-browser';
import { Router, ActivatedRoute } from '@angular/router';
import { CookieService } from 'ngx-cookie';

import { flyInOut, friends, friendLinks, messages } from './animations';
import { UserService } from '../../services/user.service';
import { SocialService } from '../../services/social.service';
import { environment } from '../../environment';

import { Account } from '../../models/account';
import { Post } from '../../models/post';
import { Friend } from '../../models/friend';
import { Conversation, Message } from '../../models/message';
import { Notification } from '../../models/notification';
import { Interaction } from '../../models/interaction';



@Component({
  selector: 'friends',
  templateUrl: './friends.html',
  providers: [ UserService, SocialService ],
  animations: [ flyInOut, friends, friendLinks, messages ]
})
export class FriendsComponent implements OnInit {

	@ViewChild('chat') private chatContainer: ElementRef;

	friendTimer: any;
	friendcount: number;
	profile: Account;
	accounts: Account;
	friends: Friend;
	requests: Friend;
	online: Friend;
	results: Friend;
	conversations: Conversation;
	messageBoxes: any;
	audio: any;
	query: string;

	messageBox = ['false'];
	showChat = false;
	showFriends = false;
	chatCheckTimer = 5000;

	friendFinder = new Finder('');
	message = new NewMessage('');

	constructor(private user: UserService,
  			  private social: SocialService,
  			  private cookie: CookieService) {

		this.audio = new Audio();
		this.audio.src = "/assets/wav/mail.m4a";
		this.audio.load();

	}

	authorize() {
		// Authorize a user
		this.user.authorizeUser().subscribe((user) =>  {
			this.accounts = user;
		})
	}




	/**
	 * Send Active / Online status
	 * Return with updated list of friends
	**/

	beOnline() {
		this.friendTimer = setInterval( () => {
	
			// Get Online Friends
			Promise.resolve(this.social.friendList()).then( (f) => {
				this.friends = f;
			});

			// Update conversations
			Promise.resolve( this.social.getConversations() ).then((covo) => {
				if ( this.conversations == covo ) {
					let msg = this.message.message;
					this.conversations = covo;
					this.message.message = msg;
				}
			});

		}, this.chatCheckTimer );
	}
	




	/**
	 * Search for people
	**/ 

	findFriends(query?) {
		this.query = (query) ? query : this.friendFinder.name;
		Promise.resolve(this.social.searchPeople(this.query)).then((result) => {
			this.friends = result;
		});
	}

	

	/**
	 * Get friends
	**/
	getFriends() {
		Promise.resolve(this.social.getRequests()).then( (r) => {
			this.requests = r;
		});
		Promise.resolve(this.social.friendList()).then((f) => {
			this.friends = f;
		});
	}


	confirmFriend(id) {
		Promise.resolve(this.social.updateFriend(id, true)).then((result) => {
			this.getFriends();
		});
	}


	ignoreFriend(id) {
		Promise.resolve(this.social.updateFriend(id, false)).then((result) => {
			this.getFriends();
		});
	}


	addFriend(id) {
		// Authorize a user
		Promise.resolve(this.social.friendRequest(id)).then((user) =>  {
			// this.friends = user;
		}).catch((err) => {
		// toss
		});
	}


	fromSelf(conversation, message) {
		for (var i = conversation.members.length - 1; i >= 0; i--) {
			if ( conversation.members[i] == message.from ) {
				return true;
			}
		}
	}


	chat(friendid) {
		Promise.resolve( this.social.newConversation(friendid) ).then((conversation) =>  {
			this.conversations = conversation;
			this.scrollChatToBottom(0);
		}).catch((err) => {
			// toss
		});
	}


	say(ev, item) {
		if ( ev.keyCode == 13 ) {
			let to = item.members[0].accountid;
			Promise.resolve( this.social.say( this.message.message, item, to ) )
				.then((conversation) =>  {
					this.message.message = '';
					this.chat(to);
					this.scrollChatToBottom(400);
				});
		}
	}


	close(conversation, i) {
		this.messageBox[i] = 'false';
		this.social.removeConversation(conversation.messageid);
	}

	/* On with the show */
	ngOnInit() {

		for (var i = 10; i >= 0; i--) { this.messageBox[i] = 'true'; }

		this.authorize();
		//this.beOnline();
		// this.getFriends();
	}


	scrollChatToBottom(n = 0) {
		setTimeout(function() {
			$("ul.messages").animate({ scrollTop: $('ul.messages').prop("scrollHeight") }, n);
		}, ( n > 0 ) ? 70 : 0 );
    }

	ngOnDestroy() {
		clearInterval(this.friendTimer);
	}

}

export class Finder {
	constructor(
		public name?: string
	) {}
}

export class NewMessage {
	constructor(
		public message?: string
	) {}
}


// WEBPACK FOOTER //
// C:/Users/Asylum/identity-vagrant/src/asylum-idenetity/src/app/user/community/friends.component.ts